import { useState, useEffect, useRef } from 'react'

const LINES = [
  { text: '$ mekong cook "Build a landing page for my startup"', cls: 'line-cmd' },
  { text: '  Plan: 3 steps identified', cls: 'line-info' },
  { text: '  Agent: cto via claude-sonnet-4-6', cls: 'line-info' },
  { text: '  [1/3] Researching startup landing patterns...', cls: 'line-info' },
  { text: '  [2/3] Generating responsive HTML + CSS...', cls: 'line-info' },
  { text: '  [3/3] Deploying to Cloudflare Pages...', cls: 'line-info' },
  { text: '  Done: https://my-startup.pages.dev', cls: 'line-success' },
  { text: '  MCU: -3 credits (balance: 197)', cls: 'line-accent' },
]

export function TerminalDemo() {
  const [count, setCount] = useState(0)
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    function start() {
      setCount(0)
      let i = 0
      intervalRef.current = setInterval(() => {
        i++
        setCount(i)
        if (i >= LINES.length) {
          if (intervalRef.current) clearInterval(intervalRef.current)
          timeoutRef.current = setTimeout(start, 3500)
        }
      }, 420)
    }
    start()
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current)
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [])

  return (
    <div className="terminal-wrapper">
      <div className="terminal">
        <div className="terminal-bar">
          <div className="terminal-dot red" />
          <div className="terminal-dot yellow" />
          <div className="terminal-dot green" />
          <span className="terminal-title">mekong-cli v6.0 — terminal</span>
        </div>
        <div className="terminal-body">
          {LINES.slice(0, count).map((line, i) => (
            <div key={i} className={`terminal-line ${line.cls}`} style={{ animationDelay: `${i * 0.05}s` }}>
              {line.text}
            </div>
          ))}
          {count < LINES.length && <span className="cursor-blink" />}
        </div>
      </div>
    </div>
  )
}
